import * as Redux from 'redux';
import { User, CoughAnalysisSet } from '../../misc/api/apiTypes';
import { PermissionEnum } from '../../misc/api/ApiPermissionEnum';
import { FetchAnalysisSetsAction } from '../CoughAnalysisActions';
import { WebPortalLegacyClientInternal } from '../../misc/api/WebPortalTokenClient';

export enum ActionType {
    OpenAssignModal = 'OpenAssignModal',
    CloseAssignModal = 'CloseAssignModal',
    InitializeUsers = 'InitializeUsers',
    RequestUsers = 'RequestUsers',
    ReceiveUsers = 'ReceiveUsers',
    SelectUsers = 'SelectUsers',
    AssignToUser = 'AssignToUser',
    ErrorRetrievingUsers = 'ErrorRetrievingUsers',
    DisableActionButton = 'DisableActionButton',
    OtherAction = 'OtherAction',
}

declare const rootUrl: string;

export class OpenAssignModalAction implements Redux.Action {
    type: ActionType.OpenAssignModal;
    analysisSetId: string;

    static create(analysisSetId: string): OpenAssignModalAction {
        return {
            type: ActionType.OpenAssignModal,
            analysisSetId: analysisSetId
        }
    }
}

export class CloseAssignModalAction implements Redux.Action {
    type: ActionType.CloseAssignModal;

    static create(): CloseAssignModalAction {
        return {
            type: ActionType.CloseAssignModal
        }
    }
}

export class SelectUsersAction implements Redux.Action {
    type: ActionType.SelectUsers;
    userId: string;

    static create(userId: string): SelectUsersAction {
        return {
            type: ActionType.SelectUsers,
            userId: userId,
        }
    }
}

export class AssignToUserAsyncAction {
    static create(legacyClient: WebPortalLegacyClientInternal, analysisSetId: string, selectedUser: string, currentStudyId: string)  {
        return dispatch => {
            dispatch(DisableActionButtonAction.create());
            this.updateAssignedAnalyst(legacyClient, analysisSetId, selectedUser).then(set => {
                dispatch(FetchAnalysisSetsAction.create(legacyClient, currentStudyId));
                dispatch(CloseAssignModalAction.create());
            });
        }
    }

    static updateAssignedAnalyst(legacyClient: WebPortalLegacyClientInternal, analysisSetId: string, userId: string): Promise<CoughAnalysisSet> {
        return legacyClient.assignToUser(analysisSetId, userId)
            .then(json => json)
    }
}

export class ErrorRetrievingUsersAction implements Redux.Action {
    type: ActionType.ErrorRetrievingUsers;
    errorMessage: string;

    static create(errorMessage: string): ErrorRetrievingUsersAction {
        return {
            type: ActionType.ErrorRetrievingUsers,
            errorMessage: errorMessage
        }
    }
}

export class DisableActionButtonAction implements Redux.Action {
    type: ActionType.DisableActionButton;

    static create(): DisableActionButtonAction {
        return {
            type: ActionType.DisableActionButton,
        }
    }
}

export class OtherAction implements Redux.Action {
    type: ActionType.OtherAction;

    static create(): OtherAction {
        return {
            type: ActionType.OtherAction
        }
    }
}

export type Action = OpenAssignModalAction | CloseAssignModalAction | SelectUsersAction | ErrorRetrievingUsersAction | DisableActionButtonAction | OtherAction;
